/* eslint-disable @typescript-eslint/no-useless-constructor */
// @ts-ignore
import BExt from '@cap/bext';
// @ts-ignore
import WxPlugin from '@fdfe/bext-plugin-weixin';
import { logger } from '../logger';
import { isInFrame } from '../runtimeEnv';

export default (baseAdapter: any) => {
  const WxAdp = WxPlugin(baseAdapter);

  class WxGYAdp extends WxAdp {
    constructor(sdk: any) {
      super(sdk);
    }

    /* eslint-enable */
    config() {
      return super.config().catch((err: Error) => {
        // 抹平在任何环境下的微信认证失败
        logger.log(err);
      });
    }

    async closeWebview() {
      this.closePage();
    }

    async closePage() {
      window.history.back();
    }

    configShare(
      opts: { channel: number[]; onlyTitle: boolean; title: string; desc: string },
      emit: any,
    ) {
      // 解决微信下动态变化url分享时描述丢失问题
      this.config().then(() => {
        logger.log('wx share->', opts);
        // 为解决分享到朋友圈描述问题，需要做两次注册
        // https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html#111
        let newOpts = {
          ...opts,
          channel: opts.channel.filter((c: number) => c !== BExt.share.WECHAT_TIMELINE),
        };

        super.configShare(newOpts, emit);

        newOpts = {
          ...opts,
          channel: [BExt.share.WECHAT_TIMELINE],
          title: opts.onlyTitle ? opts.title : opts.desc || opts.title,
        };
        super.configShare(newOpts, emit);
      });
    }

    postMsg(opts: any) {
      logger.log('postMsg: ', opts);
      /* eslint-disable no-undef */
      window.wx.miniProgram.postMessage(opts);
    }

    getEnv(opts: { success: Function; fail: Function }) {
      const { success, fail } = opts;
      /* eslint-disable no-undef */
      try {
        window.wx.miniProgram.getEnv((res: { miniprogram: any }) => {
          success(res.miniprogram);
        });
      } catch (e) {
        fail();
      }
    }

    /**
     * 跳转 WebView
     * @param {*} opts 通用传入参数
     */
    async openWebview(opts: { url: string; [key: string]: any }) {
      this.openPage(opts);
    }

    /**
     * 跳转 WebView
     * @param {*} opts 通用传入参数
     */
    async openPage(opts: { url: string; [key: string]: any }) {
      if (isInFrame()) {
        const { url } = opts;
        if (window.top) {
          window.top.location.href = url;
        }
        return;
      }
      super.openPage(opts);
    }
  }

  return WxGYAdp;
};
